export const capitalizeFirstLetter = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1)
export const wrapString = (value: string, char: string) => `${ char }${ value }${ char }`
export const isStringWrapped = (value: string, char: string) => value.startsWith(char) && value.endsWith(char)
